const textSubmissionDrawerSelectors = {
    expandedQuestionIds: state => state.textSubmissionDrawer.expandedQuestionIds,
    expandedQuestionRubricIds: state => state.textSubmissionDrawer.expandedQuestionRubricIds,
    isQuestionExpanded: questionId => state => state.textSubmissionDrawer.expandedQuestionIds.includes(questionId),
    focusedQuestionRubricId: state => state.textSubmissionDrawer.focusedQuestionRubricId,
    activeSectionKey: state => state.textSubmissionDrawer.activeSectionKey,
    gradingMode: state => state.textSubmissionDrawer.gradingMode,
    viewMode: state => state.textSubmissionDrawer.viewMode,
}

export default textSubmissionDrawerSelectors
